export const createGoogleCalendarUrl = (event) => {
  if (!event) return '';
  
  const date = new Date(event.year, event.month - 1, event.day);
  const [startHour, startMinute] = event.time.split(':').map(Number);
  const startDate = new Date(date.setHours(startHour, startMinute));
  const endDate = new Date(startDate.getTime() + 60 * 60 * 1000); // Add 1 hour

  const formatDate = (date) => {
    return date.toISOString().replace(/-|:|\.\d+/g, '');
  };

  // Extract techniques from class_name
  const classNumberIndex = event.class_name.indexOf(' - ');
  const techniqueNames = event.class_name.substring(classNumberIndex + 3);
  const techniques = techniqueNames.split(' || ').join('\n- ');

  // Get notes for this class if any
  const notes = event.notes || [];
  const notesText = notes.length > 0 
    ? `\n\nMy Notes:\n${notes.map(note => `- ${note.content}`).join('\n')}`
    : '';

  const params = {
    action: 'TEMPLATE',
    text: `Gracie Combatives Class ${event.class_number}`,
    dates: `${formatDate(startDate)}/${formatDate(endDate)}`,
    details: `Gracie Combatives Training\n\nTechniques:\n- ${techniques}${notesText}`,
    location: 'Gracie Jiu-Jitsu Academy'
  };

  return `https://calendar.google.com/calendar/render?${new URLSearchParams(params)}`;
}; 